import { combineEpics } from 'redux-observable';
import { loadDeleteDataSourcesEpicReducer } from '../ducks/DataSourceDelete.ducks';
export default combineEpics(loadDeleteDataSourcesEpicReducer.epic);

//# sourceMappingURL=DataSourceDeleteEpic.js.map
